import { render } from "./TabPlantDetailsPlotVpp.vue?vue&type=template&id=3cabd2b1&scoped=true"
import script from "./TabPlantDetailsPlotVpp.vue?vue&type=script&lang=js"
export * from "./TabPlantDetailsPlotVpp.vue?vue&type=script&lang=js"

import "./TabPlantDetailsPlotVpp.vue?vue&type=style&index=0&id=3cabd2b1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cabd2b1"]])

export default __exports__